import { Badge,Button,Tooltip, makeStyles, mergeClasses, shorthands, tokens } from '@fluentui/react-components';
import { FC } from 'react';
import { IGptConfiguration } from '../../EnterpriseGPTApi/EnterpriseGPTApiV1Client';
import { AppMenuContent } from './AppMenuContent';
import { appConfig } from '../../AppConfig';
import { useTranslation } from 'react-i18next';
import MenuBottomZone from './MenuBottomZone';
import { WIKI_URLS } from '../../constants/wikiUrls';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        backgroundColor: tokens.colorNeutralBackground1,
        ...shorthands.overflow('hidden'),
        paddingTop: '0px',
    },
    content: {
        display: 'grid',
        gridTemplateRows: 'auto 1fr',
        backgroundColor: tokens.colorNeutralBackground1,
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        ...shorthands.overflow('hidden'),
        minHeight: 0,
    },
    bottom: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: tokens.spacingVerticalM,
        flexShrink: 0,
    },
    smallDivider: {
        flexGrow: 0,
        height: '1.5rem',
    },

    workpsaceCommands: {
        display: 'flex',
        flexDirection: 'row',
        columnGap: '10px',
        justifyContent: 'center',
        maxHeight: '32px',
        ...shorthands.flex(0),
    },
    headerSection: {
        height: 'var(--mobile-header-height)',
        display: 'flex',
        borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    },
    headerContent: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        alignContent: 'center',
        gap: '0px',
        paddingLeft: `calc(${tokens.spacingHorizontalL} + ${tokens.spacingHorizontalXS})`,
        paddingRight: tokens.spacingHorizontalL,
    },
    menuContent: {
        // AppMenuContent scrolls internally, so this wrapper must stay height-constrained
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        ...shorthands.overflow('hidden'),
        paddingLeft: `calc(${tokens.spacingHorizontalL} + ${tokens.spacingHorizontalXS})`,
        paddingRight: tokens.spacingHorizontalL,
    },
});

interface AppMenuProps {
    onNewChat: (gptConfiguration: IGptConfiguration) => void;
    onCloseMenuRequired?: () => void;
}

const AppMenuMobile: FC<AppMenuProps> = ({ onNewChat, onCloseMenuRequired }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    
    const handleCloseMenu = () => {
        if (onCloseMenuRequired) {
            onCloseMenuRequired();
        }
    };
    
    const onVersionNumberClick = () => {
        window.open(WIKI_URLS.RELEASE_NOTES, '_blank');
    };
    
    const getEnvironmentLabel = (): string | undefined => {
        switch (appConfig.ENVIRONMENT) {
            case 'local':
                return 'LOCAL';
            case 'development':
                return 'DEV';
            case 'test':
                return 'TEST';
            case 'preprod':
                return 'PRE-PROD';
            default:
                return undefined;
        }
    };
    const environmentLabel = getEnvironmentLabel();
    return (
        <div className={mergeClasses(classes.root)}>
            <div className={classes.content}>
                <div className={mergeClasses("header-view__left__infoAppGroup", classes.headerSection)} > 
                    <div className={classes.headerContent}>
                        {/* Logo a Application Name */}
                        <img src="Syensqo-Logo.svg" alt="Syensqo" style={{ width: '40px', height: '40px' }}></img>
                        {t('AppTitle')}

                        {/* badges Version - Environnement */}
                        <Tooltip content={'Click to know more'} relationship='label'>
                            <Button appearance='transparent' size='small' className='version-btn' onClick={onVersionNumberClick}>
                                <Badge className="header-view__badge" >v{t('internalVersion')}</Badge>
                            </Button>
                        </Tooltip>
                        {environmentLabel && <Badge className="header-view__badgeEnvironment" > {environmentLabel} </Badge>}
                    </div>
                </div>
                
                <div className={classes.menuContent}>
                    <AppMenuContent
                        onCloseMenuRequired={handleCloseMenu}
                        onNewDraftChat={onNewChat}
                    />
                </div>
            </div>
            
            <div className={classes.bottom}>
                <MenuBottomZone onCloseMenuRequired={handleCloseMenu} />
            </div>
        </div>
    );
};

export default AppMenuMobile;
